module.exports = __webpack_public_path__ + "img/2.feb31ec5.png";